module.exports = __webpack_public_path__ + "static/img/action-account-recovery.fb4e427.svg";